<div class="ui-inputgroup" id="inputClass">
  <button pButton class="theme-button noHover labelButton" type="button" label="Position"></button>
  <input pInputText type="text" name="Position" [(ngModel)]="samplePosition" readonly />
</div>
<div class="ui-inputgroup" id="inputClass">
  <button pButton class="theme-button noHover labelButton" type="button" label="Barcode"></button>
  <input pInputText type="text" name="Barcode" [(ngModel)]="sampleBarcode" readonly />
</div>
<div class="ui-inputgroup" id="inputClass">
  <button pButton class="theme-button noHover labelButton" type="button" label="Analysis"></button>
  <input pInputText type="text" name="Analysis" [(ngModel)]="sampleType" readonly />
</div>

<div *ngFor="let table of tables">
    <div class="ui-g-12 cpValueTable">
      <div class="ui-g-12 font-weight-bold" id="processingTableHeader">
        {{table.header}}
      </div>
      <p-table [style]="{'width':'384px'}" [value]="table.channels">
        <ng-template pTemplate="header">
          <tr>
            <th scope="col">Genes</th>
            <th scope="col">Cp</th>
            <th scope="col">Result</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-channel>
          <tr style="overflow-wrap: break-word">
            <td>{{channel.gene == 'Empty' ? '' : channel.gene}}</td>
            <td>{{channel.cpValue | number:'1.0-2'}}</td>
            <td>{{channel.geneResult}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td colspan="2">
              Result
            </td>
            <td class="text-capitalize">{{table.finalresult}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
</div> 